import { falCheck } from 'shared/@generated/icons/falCheck';
import { Pressable } from 'react-native';
import { Text } from 'shared/components/text';
import { FaIcon, Icon } from 'shared/components/icon';
import { ExpandableBase, ExpandableBaseRef } from 'shared/components/form/expandable-base';
import { useRef } from 'react';

export function ExpandableSelect<T>({
  title,
  options,
  value,
  onChange,
  testID,
}: {
  title: string;
  options: { value: T | null; label: string; icon?: FaIcon }[];
  value: T | null;
  onChange: (value: T | null) => void;
  testID?: string;
}) {
  const expandableRef = useRef<ExpandableBaseRef>(null);
  const selectedIndex = Math.max(
    0,
    options.findIndex((option) => option.value === value),
  );

  return (
    <ExpandableBase
      ref={expandableRef}
      title={title}
      currentLabel={options[selectedIndex]!.label}
      testID={testID}
    >
      {options.map((option, index) => (
        <Pressable
          key={index.toString()}
          className={`hover:bg-brand-cream flex-row items-center px-3 py-2 ${selectedIndex === index ? 'bg-brand-cream rounded' : ''}`}
          onPress={() => {
            onChange(option.value);
            expandableRef.current?.close();
          }}
        >
          {option.icon && <Icon icon={option.icon} className={'mr-1.5 size-4'} />}

          <Text className={'flex-1'}>{option.label}</Text>

          {selectedIndex === index && (
            <Icon icon={falCheck} className={'text-brand-black/50 size-4'} />
          )}
        </Pressable>
      ))}
    </ExpandableBase>
  );
}
